import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { reduxBatch } from '@manaflair/redux-batch';
import { composeWithDevTools } from '@redux-devtools/extension';

import cacheThunk from './thunks/cache-thunk';
import { isIndividualPage } from '~scenes/sport/horse-racing/utils';

import Racing from './container/RacingContainer';
import ScheduleTabs from './container/ScheduleTabsContainer';
import RaceCards from './container/RaceCardsContainer';
import racingReducer from './reducers/racingReducer';

import { initialState } from '../initialState';

import '../styles/racing-widget.scss';

const propTypes = {
    widgetType: PropTypes.string.isRequired,
    showHeader: PropTypes.bool.isRequired,
    source: PropTypes.string,
    isFavouriteSport: PropTypes.bool,
    displayType: PropTypes.string,
    onFeaturedPageTabSelected: PropTypes.func,
    setSelectedId: PropTypes.func,
    resetMeetingData: PropTypes.func,
    isStreaming: PropTypes.bool,
};

const defaultProps = {
    source: '',
    isFavouriteSport: false,
};

class RacingWidget extends React.Component {

    constructor(props) {
        super(props);

        const composeEnhancers = composeWithDevTools({
            name: `Racing Widget Store [${this.props.widgetType}]`,
        });

        this.store = createStore(
            racingReducer,
            initialState,
            composeEnhancers(applyMiddleware(thunk, cacheThunk), reduxBatch),
        );
    }

    render() {
        const { isFavouriteSport = false } = this.props;

        return (
            <Provider store={this.store}>
                <Racing
                    type={this.props.widgetType}
                    showHeader={this.props.showHeader}
                    source={this.props.source}
                    isFavouriteSport={isFavouriteSport}
                    displayType={this.props.displayType}
                    setSelectedId={this.props.setSelectedId}
                    resetMeetingData={this.props.resetMeetingData}
                    isStreaming={this.props.isStreaming}
                >
                    <ScheduleTabs
                        type={this.props.widgetType}
                        source={this.props.source}
                        onFeaturedPageTabSelected={this.props.onFeaturedPageTabSelected}
                        displayType={this.props.displayType}
                    />
                    {
                        !isIndividualPage(this.props.displayType) &&
                        <RaceCards type={this.props.widgetType} source={this.props.source}/>
                    }
                </Racing>
            </Provider>
        );
    }
}

RacingWidget.propTypes = propTypes;
RacingWidget.defaultProps = defaultProps;

export default RacingWidget;
